import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Uploader,
  Icon,
  Table,
  ButtonGroup,
  IconButton,
  Input,
  Message,
  ButtonToolbar,
} from 'rsuite'
import { isImageOrPdf, isSupportFileType, isValidators } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../widgets/CustomIconMessageInfo'
import TooltipButton from '../../components/buttons/TooltipButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import InputForm from '../../components/forms/input/InputForm'

export default function AttachFilesForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  buttonText,
  isChangSeqNo = true,
  buttonTextAlign = 'left',
  onSubmit = () => {},
  onUpdate = () => {},
  onDelete = () => {},
  onPreview = () => {},
  onDownload = () => {},
  onChangSeqNo = () => {},
  ...props
}) {
  const { isEditErr, isUploadErr, isDeleteError, loading, disabledUpload, disabledEdit } = props
  const { Column, HeaderCell, Cell } = Table
  const [fileList, setFileList] = useState([])
  const [attachFiles, setAttachFiles] = useState([])
  const [selectEditeIndex, setSelectEditeIndex] = useState(-1)
  const [editName, setEditName] = useState()
  const [editDetail, setEditDetail] = useState()
  const [deleteIndex, setDeleteIndex] = useState()
  const [isAdd, setIsAdd] = useState(false)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isUploadError, setIsUploadError] = useState(false)
  const [isEditError, setIsEditError] = useState(false)
  const [isdelete, setIsdelete] = useState(false)
  const [supportFileError, setSupportFileError] = useState(false)
  const [isOverSize, setIsOverSize] = useState(false)
  const [isNotSupportType, setIsNotSupportType] = useState(false)

  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'

  useEffect(() => {
    setAttachFiles([...(schema.value || schema.values || [])])
    if (!isEditErr) {
      setEditName()
      setEditDetail()
      setSelectEditeIndex(-1)
    }
  }, [schema])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])

  useEffect(() => {
    // if (!isEditErr) {
    // console.log('isEditErr', isEditErr)
    // }
    setIsEditError(isEditErr)
  }, [isEditErr])

  useEffect(() => {
    setIsUploadError(isUploadErr)
    setIsAdd(isUploadErr)
  }, [isUploadErr])

  const onAdd = () => {
    setIsAdd(true)
    setSupportFileError(false)
    setIsEditError(false)
    setIsUploadError(false)
    setIsDeleteFail(false)
    setFileList([])
  }

  const onAddFile = (file) => {
    setFileList(file)
    setValue(schema.name, file)
  }

  const handleDeleteFile = (index) => {
    setDeleteIndex(index)
    setIsdelete(true)
  }

  const handleEditFile = (rowData, index) => {
    setEditName(rowData.label)
    setEditDetail(rowData.detail)
    setSelectEditeIndex(index)
  }

  const onUploaderChange = (files) => {
    let file = files[files.length - 1]
    let isSupportType = false
    let isSupportSize = true
    if (schema.fileType) {
      isSupportType = isSupportFileType(file?.blobFile.type, schema.fileType)
    } else {
      isSupportType = isImageOrPdf(file?.blobFile.type)
    }

    if (schema.fileSize && schema.fileSize > 0) {
      isSupportSize = file?.blobFile.size <= schema.fileSize * 1024 * 1024
      setIsOverSize(!isSupportSize)
    }

    setIsNotSupportType(!isSupportType)

    // console.log('isSupportType', isSupportType, 'isSupportSize', isSupportSize)

    if (!file || (isSupportType && isSupportSize)) {
      onAddFile(files)
      setSupportFileError(false)
    } else {
      files.splice(files.length - 1, 1)
      onAddFile(fileList)
      setSupportFileError(true)
    }
  }

  return (
    <>
      {/* <Panel header={schema.buttonText} eventKey={2} shaded style={{ marginBottom: '2em' }}> */}
      {schema.description && (
        <Row style={{ marginTop: 10 }}>
          <CustomIconMessageInfo contents={schema.description} />
        </Row>
      )}

      {!isAdd && (
        <Row style={{ marginTop: 10 }}>
          <div>
            <IconButton
              appearance="ghost"
              icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
              onClick={onAdd}
              style={{ marginRight: 5 }}
              disabled={disabledUpload}
            >
              {`เพิ่ม${schema.buttonText || buttonText || ''}`}
            </IconButton>
          </div>
        </Row>
      )}
      {isAdd && (
        <>
          <Row style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[schema.name]} />
          </Row>

          <Controller
            key={schema.name}
            name={schema.name}
            control={control}
            rules={isValidators(schema.validators)}
            defaultValue={fileList}
          />
          <Row style={{ marginTop: 10 }}>
            <p>{`แนบไฟล์${schema.buttonText || ''}`}</p>
            <Message
              showIcon
              type="info"
              description={`ชนิดที่รองรับ : ${schema.fileType || defaultSupportType} ${
                schema.fileSize && schema.fileSize > 0
                  ? `, ขนาดไฟล์ไม่เกิน ${schema.fileSize} MB`
                  : ''
              }`}
            />
          </Row>
          <Row style={{ marginTop: 10 }}>
            {supportFileError && (
              <Message
                style={{ marginTop: 10, marginBottom: 10 }}
                closable
                onClose={() => {
                  setSupportFileError(false)
                }}
                showIcon
                type="error"
                description={`${
                  isNotSupportType
                    ? `อัพโหลดไฟล์ได้เฉพาะที่รองรับเท่านั้น *** ชนิดที่รองรับ ${
                        schema.fileType || defaultSupportType
                      } ***`
                    : ''
                }  ${isOverSize ? ` ขนาดไฟล์เกิน ${schema.fileSize} MB ` : ''}`}
              />
            )}
            <Uploader
              accept={schema.fileType || defaultSupportType}
              autoUpload={false}
              fileList={props.value}
              listType="picture-text"
              onChange={(files) => {
                onUploaderChange(files)
              }}
              draggable
            >
              <div style={{ lineHeight: '100px' }}>
                <Icon size="4x" icon="upload2" />
                <small
                  style={{
                    marginTop: '-70px',
                    display: 'block',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่อใช้อัปโหลด
                </small>
              </div>
            </Uploader>
          </Row>
          {schema.attachDetail && (
            <InputForm
              schema={schema.attachDetail}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          )}
          {isUploadError && (
            <Row style={{ marginTop: 10 }}>
              <Message
                showIcon
                type="error"
                description={`อัพโหลด${
                  schema.buttonText || ''
                }ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
              />
            </Row>
          )}
          <Row style={{ marginTop: 10, textAlign: buttonTextAlign }}>
            <IconButton
              appearance="ghost"
              icon={<Icon className="bt-gost-icon-radius" icon="upload2" />}
              onClick={(e) => onSubmit()}
              style={{ marginRight: 5 }}
              disabled={loading || fileList?.length < 1}
            >
              {`อัพโหลด${schema.buttonText || ''}`}
            </IconButton>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={<Icon className="bt-gost-icon-radius-cancel" icon={'close'} />}
              onClick={(e) => {
                setIsAdd(false)
                setIsDeleteFail(false)
              }}
              style={{ marginRight: 5 }}
              disabled={loading}
            >
              {`ยกเลิก${schema.buttonText || ''}`}
            </IconButton>
          </Row>
        </>
      )}
      <Row style={{ marginTop: 10 }}>
        {isDeleteFail && (
          <Row style={{ marginTop: 10 }}>
            <Message
              showIcon
              type="error"
              description={`ลบไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
            />
          </Row>
        )}
        {isEditError && (
          <Col style={{ marginBottom: 10 }}>
            <Message
              showIcon
              type="error"
              description={`แก้ไขไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
            />
          </Col>
        )}
        <Table
          className="proposal-grantee-attach-files-table"
          height={300}
          wordWrap
          bordered
          data={attachFiles}
        >
          <Column width={90} align="center" fixed>
            <HeaderCell>ไฟล์ที่</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>
          {isChangSeqNo && (
            <Column width={100} align="center" fixed>
              <HeaderCell>จัดลำดับ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  return (
                    <ButtonGroup>
                      {rowData.isDownSeqNo && (
                        <TooltipButton
                          icon="arrow-circle-up"
                          tooltip={`เลื่อนขึ้น`}
                          disabled={loading || selectEditeIndex >= 0}
                          onClick={(e) => onChangSeqNo(rowData, rowData.seqNo - 1, index, 'UP')}
                        />
                      )}
                      {rowData.isUpSeqNo && (
                        <TooltipButton
                          icon="arrow-circle-down"
                          tooltip={`เลื่อนลง`}
                          disabled={loading || selectEditeIndex >= 0}
                          onClick={(e) => onChangSeqNo(rowData, rowData.seqNo + 1, index, 'DOWN')}
                        />
                      )}
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
          )}
          <Column minWidth={300} flexGrow={1}>
            <HeaderCell>ชื่อไฟล์</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (selectEditeIndex == index) {
                  return (
                    <Row>
                      <Col>
                        <Input value={editName} onChange={(value) => setEditName(value)} />
                      </Col>
                    </Row>
                  )
                } else {
                  return rowData.label
                }
                //return validateEditFileName(rowData, index)
              }}
            </Cell>
          </Column>
          {schema.attachDetail && (
            <Column minWidth={300} flexGrow={1}>
              <HeaderCell>{schema.attachDetail.label}</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  if (selectEditeIndex == index) {
                    return (
                      <Row>
                        <Col>
                          <Input value={editDetail} onChange={(value) => setEditDetail(value)} />
                        </Col>
                      </Row>
                    )
                  } else {
                    return rowData.detail
                  }
                  //return validateEditFileName(rowData, index)
                }}
              </Cell>
            </Column>
          )}

          <Column width={200} align="center">
            <HeaderCell className="proposal-grantee-attach-files-action-header">จัดการ</HeaderCell>
            <Cell className="proposal-grantee-attach-files-action-cell">
              {(rowData, index) => {
                return (
                  <>
                    {!rowData.disabled && (
                      <>
                        {selectEditeIndex == index ? (
                          <ButtonToolbar>
                            <ButtonGroup>
                              <IconButton
                                appearance="ghost"
                                size="sm"
                                icon={<Icon icon="save" className="bt-gost-icon-radius" />}
                                onClick={(e) => {
                                  onUpdate(rowData, editName, editDetail)
                                }}
                              />
                              <IconButton
                                appearance="ghost"
                                //className="rs-btn-ghost-cancel"
                                size="sm"
                                icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
                                onClick={(e) => {
                                  setEditName('')
                                  setIsEditError(false)
                                  setSelectEditeIndex(-1)
                                }}
                              />
                            </ButtonGroup>
                          </ButtonToolbar>
                        ) : (
                          <ButtonToolbar>
                            <ButtonGroup>
                              <TooltipButton
                                isStart={true}
                                icon="eye"
                                tooltip={`แสดง`}
                                disabled={loading}
                                onClick={(e) => onPreview(rowData)}
                              />
                              <TooltipButton
                                isStart={false}
                                icon="download"
                                tooltip={`ดาวน์โหลด`}
                                disabled={loading}
                                onClick={(e) => onDownload(rowData)}
                              />
                              {!disabledEdit && (
                                <TooltipButton
                                  isStart={false}
                                  icon="pencil"
                                  tooltip={`แก้ไข`}
                                  disabled={loading || selectEditeIndex == index}
                                  onClick={(e) => handleEditFile(rowData, index)}
                                />
                              )}
                              <TooltipButton
                                isStart={false}
                                icon="trash-o"
                                tooltip={`ลบ`}
                                disabled={loading}
                                onClick={(e) => handleDeleteFile(index)}
                              />
                            </ButtonGroup>
                          </ButtonToolbar>
                        )}
                      </>
                    )}
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Row>
      {/* </Panel> */}
      <ConfirmWidget
        title={`ยืนยันการลบ`}
        show={isdelete}
        detail={`ยืนยันการลบไฟล์ `}
        onCancle={() => {
          setIsdelete(false)
          setDeleteIndex('')
        }}
        onConfirm={() => {
          onDelete(deleteIndex)
          setIsdelete(false)
        }}
      />
    </>
  )
}
